export {
  VideoCommentaryHighlight,
  calculateVideoCommentaryHighlightMetadata,
} from './VideoCommentaryHighlight';
export type {
  VideoCommentaryHighlightProps,
  CommentItem,
  TimelineHighlightItem,
} from './types';
export {videoCommentaryHighlightSchema} from './types';
